import { useCallback, useState } from 'react';

import { Toaster } from '~components/Toaster';
import { useBotPaywallContext } from '~context/botPaywall';
import { CheckoutReason } from '~features/annals';
import { useUserId } from '~hooks/useUserId';
import { useInitiateTopicMutation } from '~services/api/topics';
import {
	Level,
	Logger,
	LoggerMessages,
	LoggerServices,
} from '~shared/services/logger';

import { INITIATE_TOPIC_TIMEOUT } from './constants';

export const useInitiateTopic = (
	botId: string
): [(topicId: string) => Promise<void>, string | undefined] => {
	const userId = useUserId();
	const [initiateTopic] = useInitiateTopicMutation();
	const [activeTopicId, setActiveTopicId] = useState<string>();
	const { openBotPaywall } = useBotPaywallContext();

	const initiate = useCallback(
		async (topicId: string) => {
			setActiveTopicId(topicId);

			try {
				// TODO: Make sure that errors get caught by catch func
				await initiateTopic({ userId, botId, topicId }).unwrap();
				setTimeout(() => setActiveTopicId(undefined), INITIATE_TOPIC_TIMEOUT);
			} catch (e) {
				if (e && typeof e === 'object' && 'status' in e && e.status === 403) {
					setActiveTopicId(undefined);
					openBotPaywall({ checkoutReason: CheckoutReason.ChatList });
					return;
				}

				setActiveTopicId(undefined);
				Toaster.showError({
					text: 'Sorry, something went wrong. Please, try again.',
				});
				Logger.shared.log(
					Level.error,
					LoggerServices.ChatService,
					LoggerMessages.InitiateTopicsError,
					{ error: e }
				);
			}
		},
		[botId, initiateTopic, openBotPaywall, userId]
	);

	return [initiate, activeTopicId];
};
